import {
  SystemSpaceSlug,
  useAuthToken,
  useSpaceUtil,
} from '@tribeplatform/react-sdk/hooks'
import { Alert } from '@tribeplatform/react-ui-kit/Alert'

import { isAdminEmailNotConfirmed } from './utils'

export const EmailVerificationBanner = () => {
  const { data: authToken } = useAuthToken()
  const { generatePath } = useSpaceUtil()

  if (!isAdminEmailNotConfirmed(authToken.member)) {
    return null
  }

  return (
    <Alert status="info" title="Admin email address is not verified">
      Please{' '}
      <a
        className="underline"
        href={generatePath(SystemSpaceSlug.VERIFY_EMAIL, null, {
          memberId: authToken.member?.id,
        })}
      >
        confirm your email address
      </a>{' '}
      to invite members.
    </Alert>
  )
}
